import React from 'react'
import GridComponent from './AddressInformationComponent'
import Card from '../../../../reusableComponents/cards/Card71'
import Button from '../../../../reusableComponents/buttons/button12'

const AddressInformation = () => {
    return (
        <div className="w-full">
            <Card
                title='Address Information'
                showPrimaryButton={true}
                showSecondaryButton={false}
                showSwapComponent1={true}
                showSwapComponent2={false}
                showSwapComponent3={false}
                showDescription={false}
                swapContent1={<GridComponent />}
                showMenuButton={false}
                primaryButtonComponent={
                    <Button
                        text="Edit"
                        state="Disabled"
                        onClick={() => { }}
                    />
                }
            />
        </div>
    )
}

export default AddressInformation